import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[slide]'
})
export class SlideDirective {
  @HostBinding('class.slideIn') @Input() slide: any;
  @HostBinding('class.slide') slideClass = true;

  constructor() {}
}
